import React from 'react';
import PropTypes from 'prop-types';

const ProxyNotification = (props) => {
  const {
    relatedObject,
    performedBy,
    variety,
  } = props;

  const proxyUserName = relatedObject.proxy_user_name || 'the selected user';
  const messageAction = variety === 'proxy_access_granted' ?
    ' granted proxy access to ' :
    ' revoked proxy access from ';
  const namelessMessage = variety === 'proxy_access_granted' ?
    'Proxy access granted to ' :
    'Proxy access revoked from ';

  const renderMessage = performedBy ? (
    <React.Fragment>
      <span className="bold-name">
        {`${performedBy.first_name} ${performedBy.last_name}`}
      </span>
      {messageAction}
      <span className="bold-name">{proxyUserName}</span>
    </React.Fragment>
  ) : (
    <React.Fragment>
      {namelessMessage}
      <span className="bold-name">{proxyUserName}</span>
    </React.Fragment>
  );

  return <p>{renderMessage}</p>;
};

export default ProxyNotification;

ProxyNotification.propTypes = {
  relatedObject: PropTypes.shape(),
  performedBy: PropTypes.shape({
    avatar: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
  variety: PropTypes.string,
};

ProxyNotification.defaultProps = {
  relatedObject: {},
  performedBy: PropTypes.shape({
    avatar: '',
    first_name: '',
    last_name: '',
  }),
  variety: '',
};
